import { AbstractControl, ValidationErrors } from '@angular/forms';
import { AppValidationError, AppValidations } from './validations';

export const hebrewNameValidator = (control: AbstractControl): ValidationErrors | null => {
  const isValid: boolean = AppValidations.ValidateHebrewName(control.value) === null;
  return !isValid ? { name: true } : null;
};
export const englishNameValidator = (control: AbstractControl): ValidationErrors | null => {
  const isValid: boolean = AppValidations.ValidateName(control.value) === null;
  return !isValid ? { name: true } : null;
};
export const englishNameOptionalValidator = (control: AbstractControl): ValidationErrors | null => {
  const isValid: boolean = AppValidations.ValidateNameOptional(control.value) === null;
  return !isValid ? { name: true } : null;
};
// Composite validators to check if the name is valid in either English or Hebrew
export const englishOrHebrewNameValidator = (control: AbstractControl): ValidationErrors | null => {
  const englishValid = AppValidations.ValidateName(control.value) === null;
  const hebrewValid = AppValidations.ValidateHebrewName(control.value) === null;

  return !englishValid && !hebrewValid ? { name: true } : null;
};

export const emailValidator = (control: AbstractControl): ValidationErrors | null => {
  const isValid: boolean = AppValidations.ValidateEmail(control.value) === null;
  return !isValid ? { email: true } : null;
};

export const nonRequiredEmailValidator = (control: AbstractControl): ValidationErrors | null => {
  const isValid: boolean = AppValidations.ValidateNonReuiredEmail(control.value) === null;
  return !isValid ? { email: true } : null;
};

export const phoneValidator = (control: AbstractControl): ValidationErrors | null => {
  const isValid: boolean = AppValidations.ValidatePhone(control.value) === null;
  return !isValid ? { phone: true } : null;
};

export const internationalPhoneValidator = (control: AbstractControl): ValidationErrors | null => {
  const isValid: boolean = AppValidations.ValidateInternationalPhone(control.value) === null;
  return !isValid ? { phone: true } : null;
};

export const israelPhoneValidator = (control: AbstractControl): ValidationErrors | null => {
  const isValid: boolean = AppValidations.IsraelValidatePhone(control.value) === null;
  return !isValid ? { phone: true } : null;
};
export const idValidator = (control: AbstractControl): ValidationErrors | null => {
  const isValid: boolean = AppValidations.ValidateISrealiID(control.value) === null;
  return !isValid ? { id: true } : null;
};

export const unRequiredIdValidator = (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }
  const isValid: boolean = AppValidations.ValidateISrealiID(control.value) === null;
  return !isValid ? { id: true } : null;
};

export const auPostcodeValidator = (control: AbstractControl): ValidationErrors | null => {
  const isValid: boolean = AppValidations.ValidatAuPostcodeAdress(control.value) === null;
  return !isValid ? { postcode: true } : null;
};

export const flightNumberValidator = (control: AbstractControl): ValidationErrors | null => {
  const validationResult = AppValidations.ValidateFlightNumber(control.value);
  if (validationResult === null) return null;
  return validationResult.required ? { required: true } : { flightNumber: true };
};

export const flightDateValidator = (control: AbstractControl, isBlurState = true): ValidationErrors | null => {
  const validationResult = AppValidations.ValidateFlightDate(control, isBlurState);
  if (!validationResult) return null;
  if (validationResult.required) return { required: true };
  return validationResult.error === AppValidationError.Errors['invalidDate']
    ? { invalidDate: true }
    : { pastDate: true };
};

export const airlineAirportNameValidator = (control: AbstractControl): ValidationErrors | null => {
  const validationResult = AppValidations.ValidateAirlineAirportNameFormat(control.value);
  if (validationResult === null) return null;
  return validationResult.required ? { required: true } : { name: true };
};

export const emailValidatorWithBlur = (control: AbstractControl, isBlurState = true): ValidationErrors | null => {
  const validationResult = AppValidations.ValidateEmailWithBlur(control.value, isBlurState);
  if (!validationResult) return null;

  if (validationResult.required) return { required: true };
  return { email: true };
};

export const requiredValidator = (control: AbstractControl): ValidationErrors | null => {
  const isValid: boolean = AppValidations.Required(control.value) === null;
  return !isValid ? { required: true } : null;
};

export const zeroStartValidator = (control: AbstractControl): ValidationErrors | null => {
  const isValid: boolean = AppValidations.ValidateZeroStart(control.value) === null;
  return !isValid ? { startWithZero: true } : null;
};

export const onlyLettersValidator = (control: AbstractControl): ValidationErrors | null => {
  const isValid: boolean = AppValidations.LettersOnly(control.value) === null;
  return !isValid ? { lettersOnly: true } : null;
};
